import './Arrows.less';

import React, { FC } from 'react';
import clsx from 'clsx';
import { SvgIcon } from '../../icons/SvgIcon';

export const ArrowSvg: FC<{ sizeX?; sizeY?; otherClassName?; fillClass?: string }> = ({
    fillClass,
    sizeX,
    sizeY,
    otherClassName
}) => {
    const arrowSizeX = sizeX ? sizeX : '12px';
    const arrowSizeY = sizeY ? sizeY : '7px';

    return (
        <SvgIcon imgId={'arrow'} sizeX={arrowSizeX} sizeY={arrowSizeY} className={clsx(fillClass, otherClassName)} />
    );
};
interface ArrowProps {
    sizeX?;
    sizeY?;
    otherClassName?;
    dataAtid?: string;
}

export const ArrowBlack: FC<ArrowProps> = ({ sizeX, sizeY, otherClassName }) => (
    <ArrowSvg fillClass="arrow-black" sizeX={sizeX} sizeY={sizeY} otherClassName={otherClassName} />
);
export const ArrowGrey: FC<ArrowProps> = ({ sizeX, sizeY, otherClassName }) => (
    <ArrowSvg fillClass="arrow-grey" sizeX={sizeX} sizeY={sizeY} otherClassName={otherClassName} />
);
export const ArrowWhite: FC<ArrowProps> = ({ sizeX, sizeY, otherClassName }) => (
    <ArrowSvg fillClass="arrow-white" sizeX={sizeX} sizeY={sizeY} otherClassName={otherClassName} />
);
export const ArrowBlue: FC<ArrowProps> = ({ sizeX, sizeY, otherClassName }) => (
    <ArrowSvg fillClass="arrow-blue" sizeX={sizeX} sizeY={sizeY} otherClassName={otherClassName} />
);
export const ArrowOrange: FC<ArrowProps> = ({ sizeX, sizeY, otherClassName }) => (
    <ArrowSvg fillClass="arrow-orange" sizeX={sizeX} sizeY={sizeY} otherClassName={otherClassName} />
);
